import { memo, useMemo } from "react";
import { X } from "lucide-react";

import { Badge } from "@/components/ui/badge";

import { buildActiveFilterChips } from "../helpers";

interface ActiveFilterChipsProps {
  filters: Record<string, any>;
  criteria: Record<string, any>;
  onRemoveFilter: (group: string, valueToRemove?: any) => void;
}

/* Visualização rápida (e removível) dos filtros aplicados, abaixo da barra. */
export const ActiveFilterChips = memo(function ActiveFilterChips({
  filters,
  criteria,
  onRemoveFilter,
}: ActiveFilterChipsProps) {
  const activeChips = useMemo(() => buildActiveFilterChips(filters, criteria), [criteria, filters]);

  if (activeChips.length === 0) return null;

  return (
    <div className="flex flex-wrap items-center gap-2 rounded-lg border border-primary/10 bg-primary/5 px-2 py-2">
      {activeChips.map((chip) => (
        <Badge key={chip.group} variant="secondary" className="gap-1.5 pl-2 pr-1.5 font-normal">
          {chip.label}
          <button
            onClick={() => onRemoveFilter(chip.group)}
            className="rounded p-0.5 transition-colors hover:bg-destructive/20 hover:text-destructive"
            aria-label={`Remover filtro ${chip.label}`}
          >
            <X className="h-3 w-3" />
          </button>
        </Badge>
      ))}
    </div>
  );
});
